import {
  applyMiddleware,
  combineReducers,
  compose as composeWithoutDevTools,
  createStore
} from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { connectRoutes } from 'redux-first-router';
import logger from 'redux-logger';
import thunk from 'redux-thunk';

import routesMap from 'app/Router/routesMap';
import routerOptions from 'app/Router/routerOptions';
import * as api from 'utils/api';
import { betterFetch } from 'utils/api/helper';

import reducers from './reducers';

/**
 * create canvas redux store
 * @param {object} initialState - initial state for the store (defaults to empty object)
 * @returns {object} store
 */
export default function createCanvasStore(initialState = {}) {
  // setup reducer
  const router = connectRoutes(routesMap, routerOptions);
  const reducer = combineReducers({ ...reducers, location: router.reducer });

  // setup enhancements
  const middlewares = [
    router.middleware,
    thunk.withExtraArgument({
      api,
      betterFetch
    }),
    process.env.NODE_ENV === 'development' && logger
  ].filter(Boolean);

  // don't use devtools in iframe
  const compose = window.frameElement
    ? composeWithoutDevTools
    : composeWithDevTools({ name: 'canvas-store' });
  const enhancements = compose(router.enhancer, applyMiddleware(...middlewares));

  return createStore(reducer, initialState, enhancements);
}
